import * as auth from './modules/auth';

export default {
  ...auth
};
